import { useEffect, useState } from "react";

import api from "./api";

const fallbackRides = [
  {
    id: 101,
    passenger_id: 12,
    driver_id: 1,
    status: "driver_arriving",
    estimated_price: 12.5,
    final_price: null,
    created_at: new Date().toISOString(),
  },
];

export default function useRides() {
  const [rides, setRides] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function fetchRides() {
      try {
        const response = await api.get("/admin/rides");
        if (isMounted) {
          setRides(response.data.data?.rides || response.data.rides || []);
        }
      } catch (error) {
        if (isMounted) {
          setRides(fallbackRides);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    fetchRides();

    return () => {
      isMounted = false;
    };
  }, []);

  return { rides, loading };
}
